export const en = {
  'enum.employeeDocumentKind.CONTRACT': 'Contract',
  'enum.employeeDocumentKind.ID': 'ID document',
  'enum.employeeDocumentKind.CERTIFICATION': 'Certificate',
  'enum.employeeDocumentKind.MEDICAL': 'Medical note',
  'enum.employeeDocumentKind.OTHER': 'Other',
  'employee.tab.documents': 'Documents',
  'employee.emergencyContact': 'Emergency contact',
  'employee.emergencyContactName': 'Emergency contact name',
  'employee.emergencyContactPhone': 'Emergency contact phone',
  'employee.probationEnds': 'Probation ends',
  'employee.probationEndsHint': 'Whoever manages the team is reminded 14 and 3 days before',
  'employee.contractEnds': 'Contract ends',
  'employee.contractEndsHint': 'For a fixed-term contract; reminded 14 and 3 days before',
  'empdocs.title': 'Documents',
  'empdocs.description': 'Contracts, IDs, certificates and medical notes, kept privately. Whoever manages the team is reminded 30 and 7 days before one expires, and so is the person.',
  'empdocs.add': 'Add document',
  'empdocs.empty': 'No documents yet',
  'empdocs.emptyHint': 'Add a signed contract, an ID or a certificate such as first aid.',
  'empdocs.col.document': 'Document',
  'empdocs.col.issued': 'Issued',
  'empdocs.col.expires': 'Expires',
  'empdocs.open': 'Open',
  'empdocs.openNamed': 'Open {title}',
  'empdocs.openFailed': 'The document could not be opened',
  'empdocs.removeNamed': 'Remove {title}',
  'empdocs.removeTitle': 'Remove “{title}”?',
  'empdocs.removeDescription': 'The file is deleted for good.',
  'empdocs.removed': 'Document removed',
  'empdocs.added': 'Document added',
  'empdocs.field.kind': 'Kind',
  'empdocs.field.title': 'Title',
  'empdocs.field.titlePlaceholder': 'e.g. First aid and CPR certificate',
  'empdocs.field.issuedOn': 'Issued on',
  'empdocs.field.expiresOn': 'Expires on',
  'empdocs.field.expiresOnHint': 'Leave empty if it never expires',
  'empdocs.field.notes': 'Notes',
  'empdocs.field.file': 'File',
  'empdocs.field.fileHint': 'PDF, JPEG or PNG, up to 10 MB',
  'empdocs.fileTooLarge': 'The file is larger than 10 MB',
  'empdocs.expiresBeforeIssued': 'It cannot expire before it was issued',
  'empdocs.noExpiry': 'No expiry',
  'empdocs.expired': 'Expired {date}',
  'empdocs.expiresToday': 'Expires today',
  'empdocs.expiresIn.one': 'Expires in {count} day',
  'empdocs.expiresIn.other': 'Expires in {count} days',
  'empdocs.validUntil': 'Valid until {date}',
  'empdocs.addedBy': 'Added by {name}, {date}',
  'empdocs.mine.title': 'My documents',
  'empdocs.mine.description': 'What the gym keeps on file for you. Ask whoever manages the team to add or replace one.',
  'empdocs.mine.empty': 'Nothing on file yet.',
  'empdocs.expiring.title': 'Expiring soon',
  'empdocs.expiring.description': 'Documents that expire, and probations and contracts that end, within 30 days.',
  'empdocs.expiring.probation': 'Probation',
  'empdocs.expiring.contract': 'Contract',
  'empdocs.expiring.ended': 'Ended {date}',
  'empdocs.expiring.endsToday': 'Ends today',
  'empdocs.expiring.endsIn.one': 'Ends in {count} day',
  'empdocs.expiring.endsIn.other': 'Ends in {count} days',
};

export const ka: Record<keyof typeof en, string> = {
  'enum.employeeDocumentKind.CONTRACT': 'ხელშეკრულება',
  'enum.employeeDocumentKind.ID': 'პირადობის დოკუმენტი',
  'enum.employeeDocumentKind.CERTIFICATION': 'სერტიფიკატი',
  'enum.employeeDocumentKind.MEDICAL': 'სამედიცინო ცნობა',
  'enum.employeeDocumentKind.OTHER': 'სხვა',
  'employee.tab.documents': 'დოკუმენტები',
  'employee.emergencyContact': 'საგანგებო კონტაქტი',
  'employee.emergencyContactName': 'საგანგებო კონტაქტის სახელი',
  'employee.emergencyContactPhone': 'საგანგებო კონტაქტის ტელეფონი',
  'employee.probationEnds': 'გამოსაცდელი ვადის დასასრული',
  'employee.probationEndsHint': 'გუნდის მენეჯერი შეხსენებას მიიღებს 14 და 3 დღით ადრე',
  'employee.contractEnds': 'ხელშეკრულების დასასრული',
  'employee.contractEndsHint': 'ვადიანი ხელშეკრულებისთვის; შეხსენება 14 და 3 დღით ადრე',
  'empdocs.title': 'დოკუმენტები',
  'empdocs.description': 'ხელშეკრულებები, პირადობის დოკუმენტები, სერტიფიკატები და სამედიცინო ცნობები, დაცულად შენახული. ვადის ამოწურვამდე 30 და 7 დღით ადრე შეხსენებას იღებს გუნდის მენეჯერი და თავად თანამშრომელიც.',
  'empdocs.add': 'დოკუმენტის დამატება',
  'empdocs.empty': 'დოკუმენტები ჯერ არ არის',
  'empdocs.emptyHint': 'დაამატეთ ხელმოწერილი ხელშეკრულება, პირადობის დოკუმენტი ან სერტიფიკატი, მაგალითად პირველადი დახმარების.',
  'empdocs.col.document': 'დოკუმენტი',
  'empdocs.col.issued': 'გაცემულია',
  'empdocs.col.expires': 'ვადა',
  'empdocs.open': 'გახსნა',
  'empdocs.openNamed': 'გახსნა: {title}',
  'empdocs.openFailed': 'დოკუმენტი ვერ გაიხსნა',
  'empdocs.removeNamed': 'წაშლა: {title}',
  'empdocs.removeTitle': 'წავშალოთ „{title}“?',
  'empdocs.removeDescription': 'ფაილი სამუდამოდ წაიშლება.',
  'empdocs.removed': 'დოკუმენტი წაიშალა',
  'empdocs.added': 'დოკუმენტი დაემატა',
  'empdocs.field.kind': 'ტიპი',
  'empdocs.field.title': 'სათაური',
  'empdocs.field.titlePlaceholder': 'მაგ. პირველადი დახმარების სერტიფიკატი',
  'empdocs.field.issuedOn': 'გაცემის თარიღი',
  'empdocs.field.expiresOn': 'ვადის ამოწურვის თარიღი',
  'empdocs.field.expiresOnHint': 'დატოვეთ ცარიელი, თუ ვადა არ აქვს',
  'empdocs.field.notes': 'შენიშვნები',
  'empdocs.field.file': 'ფაილი',
  'empdocs.field.fileHint': 'PDF, JPEG ან PNG, 10 მბ-მდე',
  'empdocs.fileTooLarge': 'ფაილი 10 მბ-ზე დიდია',
  'empdocs.expiresBeforeIssued': 'ვადა გაცემის თარიღამდე ვერ ამოიწურება',
  'empdocs.noExpiry': 'უვადო',
  'empdocs.expired': 'ვადა ამოიწურა {date}',
  'empdocs.expiresToday': 'ვადა დღეს იწურება',
  'empdocs.expiresIn.one': 'ვადა იწურება {count} დღეში',
  'empdocs.expiresIn.other': 'ვადა იწურება {count} დღეში',
  'empdocs.validUntil': 'მოქმედებს {date}-მდე',
  'empdocs.addedBy': 'დაამატა {name}, {date}',
  'empdocs.mine.title': 'ჩემი დოკუმენტები',
  'empdocs.mine.description': 'რას ინახავს დარბაზი თქვენზე. დოკუმენტის დამატება ან შეცვლა სთხოვეთ გუნდის მენეჯერს.',
  'empdocs.mine.empty': 'ჯერ არაფერია შენახული.',
  'empdocs.expiring.title': 'მალე იწურება',
  'empdocs.expiring.description': 'დოკუმენტები, რომლებსაც ვადა ეწურება, და გამოსაცდელი ვადები და ხელშეკრულებები, რომლებიც მთავრდება 30 დღეში.',
  'empdocs.expiring.probation': 'გამოსაცდელი ვადა',
  'empdocs.expiring.contract': 'ხელშეკრულება',
  'empdocs.expiring.ended': 'დასრულდა {date}',
  'empdocs.expiring.endsToday': 'დღეს მთავრდება',
  'empdocs.expiring.endsIn.one': 'მთავრდება {count} დღეში',
  'empdocs.expiring.endsIn.other': 'მთავრდება {count} დღეში',
};
